import _ from 'lodash'
import React from 'react'

export default ({ dados, EmptyState }) => WrappedComponent =>
   dados !== undefined && Array.isArray(dados) && dados.length > 0 ?
   dados.map(
      (item) => <WrappedComponent {...item} EmptyState={EmptyState} key={_.uniqueId()} />
      ) : null

